import { STANDARD_DISCLOSURE, type Partner } from "./types";

export const operationHope: Partner = {
  slug: "operation-hope",
  name: "Operation HOPE",
  fullName: "Operation HOPE, Inc.",
  path: "/partners/operation-hope",
  externalUrl: "https://operationhope.org/",
  externalLabel: "Find a HOPE Inside location",

  title: "Operation HOPE: Free Credit Coaching Before You Buy (2026)",
  description:
    "Operation HOPE puts free financial coaches inside bank branches and community sites, focused on raising credit scores and paying down debt. Who it fits, what the coaching actually covers, and how it pairs with stacking grants and down payment help.",
  h1: "Operation HOPE: free credit coaching for buyers who keep getting declined",

  cardHeadline: "Credit is the blocker? Coaching is free",
  cardBody:
    "Operation HOPE places financial coaches inside bank branches and community sites at no cost to you. The focus is exactly the thing that stalls most buyers: raising a credit score, clearing collections, and building a payment history a lender will accept. It is not a lender and it does not hand out down payment money.",
  cardPoints: ["Free one-on-one coaching", "Credit and debt focused", "No income requirement", "Months of follow-up"],

  barriers: ["credit"],
  hubSummary:
    "Free one-on-one financial coaching focused on credit scores, debt, and payment history — the most common reason a pre-approval stalls.",

  fits: [
    "Your credit score is below the 620 to 640 range most loan programs expect.",
    "You have collections, charge-offs, or thin credit history you don't know how to address.",
    "You want a real person to work through your file with you, for free, over several months.",
    "You are 6 to 24 months from buying and want to use that time productively.",
  ],
  doesNotFit: [
    "You are already pre-approved and just need down payment money.",
    "You need to close in the next 60 days.",
    "You want a lender — Operation HOPE does not originate mortgages.",
    "You are looking for a grant or cash assistance.",
  ],
  steps: [
    { title: "Find a HOPE Inside location", detail: "Coaching runs out of partner bank branches, credit unions, and community sites. Many locations also offer virtual sessions." },
    { title: "Book a free coaching session", detail: "There is no fee and no income test. You bring your credit report, income, and a list of debts." },
    { title: "Get a written plan", detail: "The coach identifies which accounts are dragging the score, in what order to pay, and what to stop doing." },
    { title: "Work the plan with check-ins", detail: "This is ongoing coaching, not a one-off appointment. Scores move over months, not weeks." },
    { title: "Come back and stack", detail: "Once your credit clears program minimums, run your Stack to see what grants and DPA you now qualify for." },
  ],
  compareLabel: "Operation HOPE",
  compare: [
    { factor: "What you get", partner: "Free financial and credit coaching", stack: "A list of grants and DPA you may qualify for" },
    { factor: "Cost", partner: "Free", stack: "Free" },
    { factor: "Timeline", partner: "Months of coaching", stack: "Minutes to see results" },
    { factor: "Fixes credit", partner: "Yes — that's the point", stack: "No" },
    { factor: "Provides money", partner: "No", stack: "Points you to program dollars" },
    { factor: "Best used", partner: "Before you apply", stack: "Once you're near program minimums" },
  ],
  faqs: [
    { q: "Does Operation HOPE cost anything?", a: "No. Coaching is free to the client. Operation HOPE is a nonprofit funded by corporate and philanthropic partners, and there is no income requirement to sit down with a coach." },
    { q: "Is this credit repair?", a: "No. Credit repair companies charge to dispute items on your behalf. Operation HOPE coaches teach you how your file works and help you build a payoff and payment-history plan you carry out yourself. Be skeptical of anyone who charges up front and promises a specific score." },
    { q: "How much can my score realistically move?", a: "It depends entirely on what's in your file. Paying down revolving balances and establishing several months of clean on-time payments tends to move scores fastest. Nobody can honestly promise you a number or a date." },
    { q: "Can I do this and use Home Approach at the same time?", a: "Yes, and you should. Coaching fixes the qualification side; running your Stack shows you what down payment money exists in your county so you know what you're working toward." },
    { q: "Does Home Approach get paid for this referral?", a: "No. We list Operation HOPE because credit is the single most common reason our members stall, and free coaching is the honest answer." },
  ],
  disclosure: STANDARD_DISCLOSURE("Operation HOPE"),
};
